<div class="home-page" (click)="start()">
    <img class="logo" src="/assets/images/volg-logo.png">
    <div class="main-title">Scannen, zahlen<br> und weiter geht's!</div>
    <div class="footer">
        <div class="div-left"><img src="/assets/images/products-home.png">
            <div>
                <h2>Produkt Barcode<br>scannen und starten<br><i class="fa-solid fa-arrow-down"></i></h2>
            </div>
        </div>
        <div class="div-right">
            <!-- <img class="qrcode" src="/assets/images/qr-code.png"> --><!-- https://forms.gle/FPz3jwL6QYrYJEXy9 <img src="/assets/images/app-name.svg"><p>Einfach mit dem Smartphone<br>die Produkte scannen und hier bezahlen.</p> -->
            <qr-code [value]="qrCodeData" darkColor="#004681" lightColor="#ffffff" size="130" />
            <div class="qrcode-title">Umfrage</div>
            <p>Helfen Sie uns!<br>Teilen Sie Ihre Meinung zur<br>Selbstbedienungskasse.</p>
        </div>
    </div>
</div>